module.exports = __webpack_public_path__ + "img/8.fc7c6fe0.svg";